"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useAddressSearch = require("../../../hooks/questionnaire/useAddressSearch");
var _services = require("../../../services");
var _SearchByMap = _interopRequireDefault(require("./SearchByMap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SearchByAddress = _ref => {
  let {
    question,
    selections
  } = _ref;
  const {
    addressSuggestions,
    address,
    streetNumber,
    onStreetNumberChange,
    minCharacters,
    onChange,
    onSelect,
    onFilter
  } = (0, _useAddressSearch.useAddressSearch)(question, selections);
  const [preselectedAddress, setPreselectedAddress] = _react.default.useState('');
  const [enableMapSearch, setEnableMapSearch] = _react.default.useState(false);
  _react.default.useEffect(() => {
    if (!enableMapSearch) {
      onChange('');
      onStreetNumberChange('');
    }
  }, [enableMapSearch]);
  if (enableMapSearch) {
    return /*#__PURE__*/_react.default.createElement(_SearchByMap.default, {
      question: question,
      selections: selections,
      preselectedAddress: preselectedAddress,
      id: "coverage-checker-search"
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "coverage-checker-search"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SearchSuggestionWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    searchSuggestion: {
      suggestions: addressSuggestions,
      value: address,
      type: 'text',
      id: 'address-search',
      placeholder: _services.locale.localeString('Questionnaire.AddressSelectorPlaceholder'),
      minCharacters,
      onChange,
      onSelect: choice => {
        onSelect(choice);
        if (choice.showMapAction) {
          setEnableMapSearch(true);
          setPreselectedAddress(choice.value);
        }
      },
      handleFiltering: async value => {
        const filters = await onFilter(value);
        if (filters.length === 1 && filters[0].hasEmptyResults) {
          return [{
            text: /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
              appearance: "secondary"
            }, _services.locale.localeString('Questionnaire.AddressSelectorSearchByMap')),
            showMapAction: true,
            value
          }];
        }
        return filters;
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    fieldWrapper: {
      label: '',
      width: 'full'
    },
    textInput: {
      type: 'text',
      id: 'address-street-number',
      placeholder: _services.locale.localeString('Questionnaire.streetNumberPlaceholder'),
      value: streetNumber,
      onChange: e => onStreetNumberChange(e.target.value)
    }
  }));
};
var _default = SearchByAddress;
exports.default = _default;